
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class CheckBox extends PureComponent {
    render() {
        let {
            required,
            plainInput,
            field,
            help,
            label,
            disabled,
            loading,
            checked,
            style,
            tooltip,
            tooltipPosition,
            onChange
        } = this.props;

        let checkbox = (
            <div>
            <input {...field}
                   type='checkbox'
                   style={style}
                   disabled={loading || disabled}
                   checked={checked}
                   onChange={onChange}/>
            </div>
        );

        if (tooltip) {
            tooltip = (<Tooltip id="tooltip">{tooltip}</Tooltip>);
            if (!tooltipPosition) {
                tooltipPosition = "top";
            }

            checkbox = (
                <OverlayTrigger placement={tooltipPosition}
                                overlay={tooltip}
                                trigger={['hover', 'focus']}>
                    {checkbox}
                </OverlayTrigger>
            );
        }

        if (plainInput) {
            return checkbox;
        }

        return (
            <FormField required={required} field={field} help={help} loading={loading} label={label}>
                {checkbox}
                {this.props.children}
            </FormField>);
    }
}

CheckBox.propTypes = {
    field: PropTypes.object,
    onChange: PropTypes.func.isRequired
}

export default CheckBox;